import React from "react";
import searchIcon from "assets/icons/searchIcon.svg";
import deleteSearchIcon from "assets/icons/search_delete.svg";
import searchDropDownIcon from "assets/icons/search_dropdown.svg";


const SearchBar = ({
    value,
    onChange,
    onClear,
    onFocus,
    className,
    placeholder = "차량번호 검색",
    handleSearchClick,
    searched,
    result = [],
}) => {
    return (<div className={`search-container ${className}`}>
        <div className={`search-input-container`}>
            <div className="nh-relative">
                <input
                    type="text"
                    id="search-input"
                    className="search-input"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onFocus={onFocus}
                />
                <img src={searchIcon} alt="search" className="search-icon" />
                <img src={deleteSearchIcon} alt="search" className={`delete-icon  ${value ? "" : "hidden"}`} onClick={onClear} />
            </div>

            {/* {searched && (
                <div className="search-dropdown" id="search-dropdown">
                    {result?.length > 0 ? (
                        result.map((item, index) => (
                            <div key={index} className="nh-result">
                                <img src={searchDropDownIcon} alt="search" />
                                <span>{item.carNum}</span>
                            </div>
                        ))
                    ) : (
                        <div className="nh-result">
                            <img src={searchDropDownIcon} alt="search" />
                            <span>자료가 한건도 없습니다.</span>
                        </div>
                    )}
                </div>
            )} */}
        </div>

        <button className="search-button" onClick={handleSearchClick}>검색</button>
    </div>);
}

export default SearchBar;